export const Status = Object.freeze({
  Enabled: 'Enabled',
  Disabled: 'Disabled',
  Deleted: 'Deleted',
});
